import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewEncapsulation,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgMedia } from '@madeinlune/drupal-types';

@Component({
  selector: 'nx-massaud-svg',
  standalone: true,
  imports: [CommonModule],
  template: ` <img [src]="media?.url" /> `,
  styleUrls: ['./svg.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SvgComponent {
  @Input()
  media: SvgMedia | undefined;
}
